import styled, { css } from 'styled-components'

import * as colors from '../../constants/colors'
import * as effects from '../../constants/effects'
import * as typography from '../../constants/typography'

export const InputRange = styled.input.attrs((props) => ({ ...props, type: 'range' }))<{
  hasDatalist: boolean
}>`
  -webkit-appearance: none !important;
  background-color: ${colors.PRIMARY_SAND_200};
  background-image: linear-gradient(${colors.PRIMARY_BLUE_700}, ${colors.PRIMARY_BLUE_700});
  background-repeat: no-repeat;
  height: 3px;
  position: relative;
  width: 100%;

  ${({ value, min, max }) => {
    if ((Number(max) - Number(min)) / Number(value) > 0) {
      return css`
        background-size: calc(100% / ((${max} - ${min}) / ${value}) - 1%) 3px;
      `
    } else {
      return css`
        background-size: ${value}% 100%;
      `
    }
  }}

  ${({ disabled }) => {
    if (disabled) {
      return css`
        background-image: linear-gradient(${colors.PRIMARY_SAND_200}, ${colors.PRIMARY_SAND_200});
      `
    }
  }}

  &::-webkit-slider-thumb {
    -webkit-appearance: none !important;
    background-color: ${colors.PRIMARY_SAND_200};
    border-radius: 100%;
    border: 4px solid ${colors.PRIMARY_GREY_000};
    box-sizing: border-box;
    box-shadow: ${effects.SHADOW_1};

    height: 22px;
    position: relative;
    top: ${({ hasDatalist }) => (hasDatalist ? '-10px' : 0)};
    transition: background-color 0.3s ease;
    width: 22px;

    ${({ disabled }) => {
      if (!disabled) {
        return css`
          cursor: grab;

          &:hover {
            background-color: ${colors.PRIMARY_BLUE_700};
          }
        `
      }
    }}
  }

  &::-moz-range-thumb {
    appearance: none;
    background-color: ${colors.PRIMARY_SAND_200};
    border-radius: 100%;
    border: 4px solid ${colors.PRIMARY_GREY_000};
    box-sizing: border-box;
    box-shadow: ${effects.SHADOW_1};
    cursor: grab;
    height: 22px;
    position: relative;
    top: ${({ hasDatalist }) => (hasDatalist ? '-10px' : 0)};
    transition: background-color 0.3s ease;
    width: 22px;

    &:hover {
      background-color: ${colors.PRIMARY_BLUE_700};
    }
  }
`

export const Datalist = styled.datalist<{ $id: string }>`
  display: flex;
  justify-content: space-between;
  left: 8px;
  padding-top: 0;
  position: relative;
  top: 8px;
  width: 100%;
`

export const Option = styled.option`
  ${typography.HEADING_5XS};
  color: ${colors.PRIMARY_SAND_500} !important;
  display: flex;
  justify-content: center;
  z-index: 1;
`
